__turbopack_context__.v({
  "bold": "insuranceWarning-module-scss-module__zBadka__bold",
  "content": "insuranceWarning-module-scss-module__zBadka__content",
  "description": "insuranceWarning-module-scss-module__zBadka__description",
  "footerText": "insuranceWarning-module-scss-module__zBadka__footerText",
  "header": "insuranceWarning-module-scss-module__zBadka__header",
  "headerText": "insuranceWarning-module-scss-module__zBadka__headerText",
  "icon": "insuranceWarning-module-scss-module__zBadka__icon",
  "insuranceWarning": "insuranceWarning-module-scss-module__zBadka__insuranceWarning",
  "list": "insuranceWarning-module-scss-module__zBadka__list",
  "listItem": "insuranceWarning-module-scss-module__zBadka__listItem",
});
